import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './components/app/App';
import './index.scss';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { Analytics } from "@vercel/analytics/react"

disableReactDevTools();
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
  );
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<App />
			<Analytics />
		</PersistGate>
	</Provider>
);
